import React from 'react';
import { Box, Table, TableHead, TableRow, TableCell, TableBody, Skeleton } from '@mui/material';

const PurchasesListSkeleton: React.FC<{ listLength: number }> = ({ listLength }) => {
  const elementsToShow = listLength < 3 ? 3 : listLength;
  return (
    <Box data-testid="payment-skeleton">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>App key</TableCell>
            <TableCell>From date</TableCell>
            <TableCell>Expiration date</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(elementsToShow)].map((a, i) => (
            <TableRow key={i} hover>
              <TableCell>
                <Skeleton variant="rectangular" height={22} width={150} />
              </TableCell>
              <TableCell>
                <Skeleton variant="rectangular" height={22} width={150} />
              </TableCell>
              <TableCell>
                <Skeleton variant="rectangular" height={22} width={150} />
              </TableCell>
              <TableCell>
                <Skeleton variant="rectangular" height={22} width={150} />
              </TableCell>
              <TableCell
                style={{
                  display: 'flex',
                  width: '100%',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'flex-end',
                  height: '84px',
                }}
              >
                <Skeleton variant="rectangular" height={15} width={25} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default PurchasesListSkeleton;
